export default __webpack_public_path__ + "static/nfl-e0d2a4b463ab1320d2651a5aa6894c21.png";